import React from 'react';

const base = {
  width: 28,
  height: 28,
  viewBox: '0 0 32 32',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export const ForkliftIcon = (p) => (
  <svg {...base} {...p}>
    <path d="M4 22h14V8h6l4 6v8h-2" />
    <circle cx="8" cy="24" r="2.4" />
    <circle cx="22" cy="24" r="2.4" />
    <path d="M18 22V8" />
    <path d="M14 22V12h-3v10" />
    <path d="M2 14v8" />
    <path d="M2 18h2" />
  </svg>
);

export const RocketIcon = (p) => (
  <svg {...base} {...p}>
    <path d="M14 22l-4-4 8-12 6 6-12 8z" />
    <path d="M10 18l-4 2 2-6" />
    <circle cx="19" cy="13" r="1.5" />
    <path d="M6 26l4-4" />
  </svg>
);

export const ReachIcon = (p) => (
  <svg {...base} {...p}>
    <path d="M3 22h26" />
    <path d="M6 22V8h6l3 4v10" />
    <path d="M15 12h12" />
    <path d="M27 12V6" />
    <circle cx="9" cy="24" r="2" />
    <circle cx="14" cy="24" r="2" />
  </svg>
);

export const BadgeIcon = (p) => (
  <svg {...base} {...p}>
    <path d="M16 4l3 3 4-1 1 4 3 3-3 3 1 4-4-1-3 3-3-3-4 1 1-4-3-3 3-3-1-4 4 1z" />
    <path d="M12 16l3 3 5-6" />
  </svg>
);

export const LicenseIcon = (p) => (
  <svg {...base} {...p}>
    <rect x="3" y="7" width="26" height="18" rx="2" />
    <circle cx="10" cy="14" r="3" />
    <path d="M16 12h10" />
    <path d="M16 16h7" />
    <path d="M6 21h20" />
  </svg>
);

export const CertificateIcon = (p) => (
  <svg {...base} {...p}>
    <rect x="4" y="4" width="24" height="18" rx="2" />
    <path d="M8 10h16" />
    <path d="M8 14h10" />
    <circle cx="22" cy="22" r="4" />
    <path d="M22 26v4l-2-1-2 1v-4" />
  </svg>
);

export const ShieldIcon = (p) => (
  <svg {...base} {...p}>
    <path d="M16 3l11 4v9c0 7-5 11-11 13-6-2-11-6-11-13V7z" />
    <path d="M11 16l3 3 6-7" />
  </svg>
);

export const ClockIcon = (p) => (
  <svg {...base} {...p}>
    <circle cx="16" cy="16" r="12" />
    <path d="M16 9v7l5 3" />
  </svg>
);

export const PhoneIcon = (p) => (
  <svg {...base} {...p}>
    <path d="M5 5h6l2 6-3 2c1 3 4 6 7 7l2-3 6 2v6c0 1-1 2-2 2C13 27 5 19 5 8c0-1 0-3 0-3z" />
  </svg>
);

export const MailIcon = (p) => (
  <svg {...base} {...p}>
    <rect x="3" y="6" width="26" height="20" rx="2" />
    <path d="M3 8l13 9 13-9" />
  </svg>
);

export const MapPinIcon = (p) => (
  <svg {...base} {...p}>
    <path d="M16 3c5 0 9 4 9 9 0 7-9 17-9 17S7 19 7 12c0-5 4-9 9-9z" />
    <circle cx="16" cy="12" r="3" />
  </svg>
);

export const StarIcon = (p) => (
  <svg {...base} fill="currentColor" stroke="none" {...p}>
    <path d="M16 3l3.6 8.7 9.4.8-7.1 6 2.2 9.2L16 22.9 7.9 27.7l2.2-9.2L3 12.5l9.4-.8z" />
  </svg>
);

export const TruckIcon = (p) => (
  <svg {...base} {...p}>
    <rect x="2" y="8" width="15" height="12" rx="1" />
    <path d="M17 12h6l4 4v4h-3" />
    <circle cx="7" cy="22" r="2.4" />
    <circle cx="22" cy="22" r="2.4" />
  </svg>
);

export const ChevronRight = (p) => (
  <svg {...base} {...p}>
    <path d="M12 6l8 10-8 10" />
  </svg>
);

export const ChevronDown = (p) => (
  <svg {...base} {...p}>
    <path d="M6 12l10 8 10-8" />
  </svg>
);

export const MenuIcon = (p) => (
  <svg {...base} {...p}>
    <path d="M4 8h24" />
    <path d="M4 16h24" />
    <path d="M4 24h24" />
  </svg>
);

export const CloseIcon = (p) => (
  <svg {...base} {...p}>
    <path d="M6 6l20 20" />
    <path d="M26 6L6 26" />
  </svg>
);

export const CheckIcon = (p) => (
  <svg {...base} {...p}>
    <path d="M5 17l7 7L27 8" />
  </svg>
);

export const ArrowRight = (p) => (
  <svg {...base} {...p}>
    <path d="M5 16h22" />
    <path d="M19 8l8 8-8 8" />
  </svg>
);

export const FaxIcon = (p) => (
  <svg {...base} {...p}>
    <rect x="7" y="3" width="18" height="8" rx="1" />
    <rect x="3" y="11" width="26" height="14" rx="2" />
    <rect x="11" y="17" width="10" height="6" />
    <circle cx="24" cy="15" r="1" fill="currentColor" />
  </svg>
);

export const HardHatIcon = (p) => (
  <svg {...base} {...p}>
    <path d="M4 22h24" />
    <path d="M6 22v-3a10 10 0 0120 0v3" />
    <path d="M13 12V8h6v4" />
  </svg>
);

export const UsersIcon = (p) => (
  <svg {...base} {...p}>
    <circle cx="12" cy="11" r="4" />
    <path d="M4 24c1-4 4-7 8-7s7 3 8 7" />
    <circle cx="22" cy="10" r="3" />
    <path d="M20 17c4 0 7 3 8 6" />
  </svg>
);
